export default __webpack_public_path__ + "static/media/step5-3.16496e3d.png";